import React, { useContext, useEffect, useState } from 'react';
import { AnyIfEmpty, useSelector } from 'react-redux';
import { IRootState } from '../../../redux/rootReducer';
import { AvailabilityRedirectionContext } from '../../context/availabilityRedirection';
import AddAvailabilityForm from './AddAvailabilityForm/AddAvailabilityForm';
import AvailabilityCalendar from './AvailabilityCalendar/AvailabilityCalendar';
import AvailabilityConfirm from './AvailabilityConfirm/AvailabilityConfirm';
import ConflictDelete from './ConflictDelete/ConflictDelete';
import SelectLocation from './SelectLocation/SelectLocation';
import SelectLocker from './SelectLocker/SelectLocker';
import SelectUnit from './SelectUnit/SelectUnit';

interface props {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    AvailabilityList: AnyIfEmpty<object>;
    setShowToast?: React.Dispatch<React.SetStateAction<boolean>>;
    setToastMessage?: React.Dispatch<React.SetStateAction<string>>;
}

const AddAvailability = ({ setOpen, AvailabilityList, setShowToast, setToastMessage, }: props) => {
    const conflictedAvailabilityData = useSelector((state: IRootState) => state.availability.conflictedAvailability.data);
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const lockerType = availabilityRedirectionContext?.locationDetails?.lockerName;

    const [showLocation, setShowLocation] = useState(true);
    const [showUnits, setShowUnits] = useState(false);
    const [showLocker, setShowLocker] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const [showConflicts, setShowConflicts] = useState(false);
    const [showConflictDelete, setShowConflictDelete] = useState(false);

    const [addAvailabilityObj, setAddAvailabilityObj]: AnyIfEmpty<object> = useState({
        locationId: '',
        unitId: '',
        locker: null,
        startDate: '',
        endDate: '',
        openingTime: '',
        closingTime: '',
        locationName: '',
        unitName: '',
    });

    useEffect(() => {
        if (
            availabilityRedirectionContext?.availabilityData.locationId &&
            availabilityRedirectionContext?.availabilityData.unitId &&
            availabilityRedirectionContext.availabilityData.slotRange &&
            availabilityRedirectionContext.availabilityData.locationName &&
            availabilityRedirectionContext.availabilityData.lockerNumber &&
            availabilityRedirectionContext.availabilityData.unitName
        ) {
            const [openingTime, closingTime] = availabilityRedirectionContext.availabilityData.slotRange.split(' - ');
            setAddAvailabilityObj((prevState: any) => {
                return {
                    ...prevState,
                    locationId: availabilityRedirectionContext?.availabilityData.locationId,
                    unitId: availabilityRedirectionContext?.availabilityData.unitId,
                    startDate: availabilityRedirectionContext?.availabilityData.selectedDate,
                    endDate: availabilityRedirectionContext?.availabilityData.selectedDate,
                    openingTime,
                    closingTime,
                    locationName: availabilityRedirectionContext?.availabilityData.locationName,
                    locker: availabilityRedirectionContext.availabilityData.lockerNumber,
                    unitName: availabilityRedirectionContext.availabilityData.unitName,
                };
            });
            setShowLocation(false);
            setShowLocker(false);
            setShowCalendar(false);
            setShowConfirm(true);
        }
    }, [availabilityRedirectionContext]);

    return (
        <div>
            {/* Location Popup */}
            {showLocation && (
                <SelectLocation
                    setShowLocation={setShowLocation}
                    setShowUnits={setShowUnits}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                    AvailabilityList={AvailabilityList}
                    addAvailabilityObj={addAvailabilityObj}
                />
            )}

            {/* Unit Popup */}
            {showUnits && (
                <SelectUnit
                    setShowLocation={setShowLocation}
                    setShowUnits={setShowUnits}
                    setShowLocker={setShowLocker}
                    locationId={addAvailabilityObj.locationId}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                    addAvailabilityObj={addAvailabilityObj}
                />
            )}

            {/* Locker Popup */}
            {showLocker && (
                <SelectLocker
                    setShowUnits={setShowUnits}
                    setShowLocker={setShowLocker}
                    setShowCalendar={setShowCalendar}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                    addAvailabilityObj={addAvailabilityObj}
                />
            )}

            {/* Availability Calendar Popup */}
            {showCalendar && (
                <AvailabilityCalendar
                    setShowLocker={setShowLocker}
                    setShowCalendar={setShowCalendar}
                    setShowForm={setShowForm}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                />
            )}

            {/* Add Availability Popup */}
            {showForm && (
                <AddAvailabilityForm
                    setShowCalendar={setShowCalendar}
                    setShowForm={setShowForm}
                    setShowConfirm={setShowConfirm}
                    addAvailabilityObj={addAvailabilityObj}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                    setShowToast={setShowToast}
                    setToastMessage={setToastMessage}
                />
            )}

            {/* Availability Confirm */}
            {showConfirm && (
                <AvailabilityConfirm

                    setShowForm={setShowForm}
                    setShowConfirm={setShowConfirm}
                    addAvailabilityObj={addAvailabilityObj}
                    setShowConflicts={setShowConflicts}
                    setAddAvailabilityObj={setAddAvailabilityObj}
                    setShowCalendar={setShowCalendar}
                    setOpen={setOpen}
                    setShowConflictDelete={setShowConflictDelete}
                    showConflicts={showConflicts}
                    showConflictDelete={showConflictDelete}
                />
            )}

            {showConflictDelete && (
                <ConflictDelete
                    setShowConflictDelete={setShowConflictDelete}
                    data={conflictedAvailabilityData}
                    addAvailabilityObj={addAvailabilityObj}
                    setShowConfirm={setShowConfirm}
                />
            )}
        </div>
    );
};

export default AddAvailability;
